export const prefersReducedMotion = () => typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/** cubic-bezier(0.23, 1, 0.32, 1): the ease-out curve of the portal polish, solved for x. */
export const easeOutQuiet = (x) => {
    if (x <= 0)
        return 0;
    if (x >= 1)
        return 1;
    const p1x = 0.23;
    const p1y = 1;
    const p2x = 0.32;
    const p2y = 1;
    const a = (a1, a2) => 1 - 3 * a2 + 3 * a1;
    const b = (a1, a2) => 3 * a2 - 6 * a1;
    const c = (a1) => 3 * a1;
    const curve = (t, a1, a2) => ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
    const slope = (t, a1, a2) => 3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
    let t = x;
    for (let i = 0; i < 8; i += 1) {
        const s = slope(t, p1x, p2x);
        if (Math.abs(s) < 1e-6)
            break;
        t -= (curve(t, p1x, p2x) - x) / s;
    }
    return curve(Math.min(1, Math.max(0, t)), p1y, p2y);
};
